import React from 'react';
import studioImage from '../images/about/ram-tirath-art-studio.jpg';

const ArtistProfile = () => {
  return (
    <section id="about" className="py-20 bg-white">
      <div className="w-full mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white rounded-2xl shadow-lg overflow-hidden">
          <div className="grid grid-cols-1 lg:grid-cols-2">
            <div className="artist-image relative h-64 sm:h-80 md:h-96 lg:h-auto bg-gray-100">
              <img
                src={studioImage}
                alt="Ram Tirath Art Studio - Handmade Sculptures India, Custom Sculpture Makers, Fiberglass and Metal Sculpture Artists Workshop"
                className="w-full h-full object-contain"
              />
              <div className="absolute inset-0 bg-black bg-opacity-20"></div>
            </div>

            {/* Right Side - Content */}
            <div className="artist-content p-8 lg:p-12">
              <h3 className="text-2xl md:text-3xl font-bold text-gray-800 mb-6">Ram Tirath Art - Leading Sculpture Studio India</h3>

              <div className="space-y-6 text-gray-600 leading-relaxed">
                <p className="text-lg">
                  Welcome to Ram Tirath Art, India's premier <strong>custom sculpture makers</strong> and leading name in <strong>handmade sculptures India</strong>.
                  Our <strong>art sculpture company</strong> specializes in crafting exquisite <strong>custom bust sculptures</strong>, <strong>life-size statue makers</strong> creations,
                  stunning <strong>3D wall mural artists</strong> installations, and bespoke artistic pieces that bring imagination to life.
                </p>

                <p>
                  As professional <strong>fiberglass sculpture artists</strong> and expert <strong>metal sculpture creators</strong>, our skilled artisans work with premium materials
                  including fiber glass, metal, and other durable mediums. Our <strong>artistic statue manufacturers</strong> ensure every sculpture stands out in beauty,
                  detail, and longevity. Whether you need a custom statue, decorative wall mural, or unique art piece for your space,
                  we create designs that reflect your vision and elevate your environment.
                </p>

                <p>
                  With years of experience as a trusted <strong>sculpture studio India</strong>, our goal is to deliver high-quality,
                  timeless creations that blend traditional Indian craftsmanship with modern creativity. From custom sculptures
                  to large-scale installations, we are your dedicated partners in bringing artistic visions to reality.
                </p>

                {/* Philosophy integrated into content */}
                <div className="bg-primary-50 rounded-lg p-4 mt-6">
                  <p className="text-lg font-medium text-primary-800 italic text-center">
                    "At Ram Tirath Art, we believe art is more than decoration — it's a story carved with passion, precision, and purpose."
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Additional Content Section */}
          <div className="px-8 lg:px-12 pb-8">
            {/* Stats Section */}
            <div className="mt-8 pt-8 border-t border-gray-200">
              <div className="grid grid-cols-1 md:grid-cols-4 gap-6 text-center">
                <div>
                  <div className="text-2xl font-bold text-primary-600">15+</div>
                  <div className="text-sm text-gray-600">Years Experience</div>
                </div>
                <div>
                  <div className="text-2xl font-bold text-primary-600">1000+</div>
                  <div className="text-sm text-gray-600">Sculptures Created</div>
                </div>
                <div>
                  <div className="text-2xl font-bold text-primary-600">200+</div>
                  <div className="text-sm text-gray-600">Installations</div>
                </div>
                <div>
                  <div className="text-2xl font-bold text-primary-600">100%</div>
                  <div className="text-sm text-gray-600">Handmade Quality</div>
                </div>
              </div>
            </div>

            {/* Workshops and Participations Section */}
            <div className="mt-12 pt-8 border-t border-gray-200">
              <h4 className="text-xl font-bold text-gray-800 mb-6 flex items-center">
                <span className="w-8 h-8 bg-primary-100 text-primary-600 rounded-lg flex items-center justify-center mr-3">
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                  </svg>
                </span>
                Workshops and Participations
              </h4>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-4">
                {[
                  "Prithivi Kala Mahotsav Org. by IIM Lucknow",
                  "Group exhibition in Lalit Kala Academy 2008",
                  "Art Fair Org. by University of Lucknow 2008-2011",
                  "Puratatva Art Painting in Zoo of Lucknow",
                  "Open Air Sculptures Exhibition in Varanshi",
                  "Wild Life Programme University of Lucknow 2009",
                  "Academic Tour to Ajanta and Ellora 2010",
                  "Maha Kumbh-2019 Prayagraj U.P.",
                  "Deepotsav 2019, 2020 Ayodhya"
                ].map((item, index) => (
                  <div key={index} className="flex items-start">
                    <span className="text-primary-500 mr-3 mt-1 text-lg">•</span>
                    <span className="text-gray-600">{item}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ArtistProfile;
